import axios from "axios";
import { FileManager, ServerAddress } from "../Enum/Urls";

export const uploadFile = async (param, LAN, token) => {
    
    if (!token) {
        return
    }

    try {
        let response = await axios.post(`${ServerAddress.Type}${ServerAddress.FileManager}${FileManager.Upload}`,
            param,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': `${LAN === 'IR' ? 'fa-IR' : 'en-US'}`,
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${token}`
                }
            },
        )
        return response
    } catch (error) {
        return error
    }
}
export const downloadFile = async (param, LAN, token) => {

    try {
        let response = await axios.post(`${ServerAddress.Type}${ServerAddress.FileManager}${FileManager.Download}`,
            param,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': `${LAN === 'IR' ? 'fa-IR' : 'en-US'}`,
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${token}`
                }
            },
        )
        return response
    } catch (error) {
        return error
    }
}

export const downloadPdf = async (params, headerParams) => {
    try {
        let response = await axios.get(`${ServerAddress.Type}${ServerAddress.PdfGenerator}${FileManager.GetPdf}?Type=${params.Type}&ReserveId=${params.ReserveId}&Username=${params.Username}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': `${headerParams.LAN === 'IR' ? 'fa-IR' : 'en-US'}`,
                    "tenantid": process.env.REACT_APP_SERVER_TENANTID,
                    Authorization: `Bearer ${headerParams.token}`,
                    currency:headerParams.currency
                }
            },
        )
        return response
    } catch (error) {
        return error
    }
}
